// index.js
import React from 'react';
import { createRoot } from 'react-dom/client'; // Import createRoot
import './index.css'; // Ensure your CSS is imported
import App from './App';
import { ThemeProvider } from './ThemeContext'; // Ensure ThemeProvider is imported correctly

const container = document.getElementById('root');
const root = createRoot(container); // Create a root.

root.render(
  <ThemeProvider>
    <App />
  </ThemeProvider>
);
